var _this = this,
    _jsxFileName = "/home/teuteuf/workspace/web/react-pwa-install/src/InstallDialog.js";

import React from "react";
import { Grid, Box, Typography, Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import InstallDialogAction from "./InstallDialogAction";

var InstallDialog = function InstallDialog(props) {
  var theme = useTheme();
  var fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  return /*#__PURE__*/React.createElement(Dialog, {
    open: props.open,
    onClose: props.onClose,
    "aria-labelledby": "dialog-title",
    fullScreen: fullScreen,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "dialog-title",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 7
    }
  }, props.title || "Install Web App"), /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    style: {
      height: '100%'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }, !!props.logo && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: props.logo,
    alt: "logo",
    style: {
      width: '100%'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 17
    }
  }))), !!props.features && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 17
    }
  }, props.featuresTitle || "Key Features:"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "div",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 17
    }
  }, props.features))), !!props.description && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 15
    }
  }, props.descritpionTitle || "Description:"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "div",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 15
    }
  }, props.description)))), /*#__PURE__*/React.createElement(DialogContent, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InstallDialogAction, {
    platform: props.platform,
    onSubmit: props.onSubmit,
    onClose: props.onClose,
    instructionTitle: props.instructionTitle,
    instructionActionOk: props.instructionActionOk,
    instructionActionCancel: props.instructionActionCancel,
    instructionActionInstall: props.instructionActionInstall,
    instructionIdeviceAction1: props.instructionIdeviceAction1,
    instructionIdeviceAction2: props.instructionIdeviceAction2,
    instructionFirefoxAction1: props.instructionFirefoxAction1,
    instructionFirefoxAction2: props.instructionFirefoxAction2,
    instructionFirefoxNewAction1: props.instructionFirefoxNewAction1,
    instructionFirefoxNewAction2: props.instructionFirefoxNewAction2,
    instructionOperaAction1: props.instructionOperaAction1,
    instructionOperaAction2: props.instructionOperaAction2,
    instructionNotSupported: props.instructionNotSupported,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  })));
};

export default InstallDialog;